import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  useTheme,
  Tooltip,
} from '@mui/material';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';

function StalledErrorCard({ pipeline, isActive, onToggle }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Tooltip title="Stalled Error simulation - Coming soon">
      <Card
        sx={{
          opacity: 0.5,
          background: isDark
            ? 'rgba(255, 255, 255, 0.03)'
            : 'rgba(0, 0, 0, 0.02)',
          border: `1px solid ${isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)'}`,
          cursor: 'not-allowed',
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            py: 1.5,
            px: 1,
            minHeight: 80,
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            <PauseCircleOutlineIcon
              sx={{
                fontSize: 28,
                color: isDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)',
              }}
            />
            <Typography
              variant="caption"
              sx={{
                fontWeight: 600,
                color: 'text.disabled',
                textAlign: 'center',
                lineHeight: 1.2,
              }}
            >
              Stalled
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontSize: '0.6rem',
                color: 'text.disabled',
              }}
            >
              Coming soon
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Tooltip>
  );
}

export default StalledErrorCard;
